var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.072,
    height: 35.182,
    viewBox: "0 0 31.072 35.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.902 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.588.448A3.052,3.052,0,0,0,31.66.308l15.8,15.829,5.165-5.189Zm-4.38,1.325A3.219,3.219,0,0,0,29.9,3.148V32.1a3.1,3.1,0,0,0,.309,1.361L46,17.6ZM47.457,19.058,31.687,34.9A3.1,3.1,0,0,0,33,35.182a3.063,3.063,0,0,0,1.593-.429L52.623,24.236Zm12.03-4.111-.019-.012-5.007-2.916L48.911,17.6l5.554,5.565,5.022-2.928a3.093,3.093,0,0,0,0-5.286Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google_play.454dcc622967504aada3f6ee11a2a70a.svg";
export { ForwardRef as ReactComponent };